import { get } from 'lodash';

class FormErrorModel {
    constructor() {
        this.flattenedErrors = {
            memberProducts: {},
            parent: {}
        };
    }

    setFormErrors(errors) {
        this.flattenErrors(errors);
    }

    flattenErrors(errors) {
        this.flattenedErrors.parent = get(errors, 'errors');
        this.flattenedErrors.memberProducts = get(errors, 'children.memberProducts.children');
    }

    get memberProducts() {
        return this.flattenedErrors['memberProducts'];
    }

    get parent() {
        return this.flattenedErrors['parent'];
    }
}

export default FormErrorModel;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/request-product/model/form-error.model.js